import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'

import injectRole from '../../components/HOC/injectRole'
import { TRoles, TRoutes } from '../../shared/const'

import Connections from '../../components/views/supporter/Connections'

function SupporterConnectionsPage(props) {
	if (props.role === TRoles.SUPPORTER) return <Connections />

	return <Redirect to={TRoutes.DASHBOARD} />
}

SupporterConnectionsPage.propTypes = {
	role: PropTypes.string.isRequired
}

export default injectRole(SupporterConnectionsPage)
